import React from "react"
import clsx from "clsx"

export interface FormikCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  id?: string
  name: string
  onChanges: (name: string, value: string) => void
  fieldValue: any
}

export const FormikCheckbox: React.FC<FormikCheckboxProps> = ({
  className,
  id,
  name,
  onChanges,
  fieldValue,
  value,
  children,
  ...props
}) => {
  const handleChange = () => {
    if (!fieldValue) {
      onChanges(name, "")
    } else if (fieldValue.includes(value)) {
      const arr = fieldValue.filter((v: any) => v !== value)
      onChanges(name, arr)
    } else {
      const arr = fieldValue.concat(value)
      onChanges(name, arr)
    }
  }
  return (
    <div className={clsx("checkbox", className)}>
      <input type="checkbox" id={id} name={name} {...props} onChange={handleChange} />
      <label htmlFor={id}>{children}</label>
    </div>
  )
}
